import { FC } from "react";
import { IconProps } from "../svg/SVGIconsCollection";

export const SearchIcon: FC<IconProps> = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7417 10.8431C12.71 9.52181 13.1437 7.88361 12.956 6.25627C12.7683 4.62893 11.9731 3.13246 10.7294 2.06625C9.48579 1.00004 7.88543 0.442727 6.24851 0.505801C4.6116 0.568874 3.05886 1.24769 1.90095 2.40643C0.743029 3.56518 0.0653277 5.1184 0.00342583 6.75536C-0.058476 8.39231 0.499986 9.99228 1.56708 11.2352C2.63418 12.4781 4.13122 13.2722 5.7587 13.4587C7.38617 13.6452 9.02406 13.2104 10.3447 12.2411H10.3437C10.3737 12.2811 10.4057 12.3191 10.4417 12.3561L14.2917 16.2061C14.4792 16.3938 14.7336 16.4992 14.9988 16.4993C15.2641 16.4994 15.5185 16.3941 15.7062 16.2066C15.8938 16.0191 15.9993 15.7647 15.9994 15.4995C15.9995 15.2342 15.8942 14.9798 15.7067 14.7921L11.8567 10.9421C11.8209 10.9059 11.7825 10.8725 11.7417 10.8421V10.8431ZM11.9997 6.99912C11.9997 7.72139 11.8574 8.43659 11.581 9.10388C11.3046 9.77117 10.8995 10.3775 10.3888 10.8882C9.87804 11.3989 9.27173 11.8041 8.60444 12.0805C7.93715 12.3569 7.22195 12.4991 6.49968 12.4991C5.77741 12.4991 5.06221 12.3569 4.39492 12.0805C3.72763 11.8041 3.12131 11.3989 2.61059 10.8882C2.09987 10.3775 1.69474 9.77117 1.41834 9.10388C1.14194 8.43659 0.999677 7.72139 0.999677 6.99912C0.999677 5.54043 1.57914 4.14149 2.61059 3.11004C3.64204 2.07859 5.04099 1.49912 6.49968 1.49912C7.95837 1.49912 9.35731 2.07859 10.3888 3.11004C11.4202 4.14149 11.9997 5.54043 11.9997 6.99912Z"
        fill="#05386B"
      />
    </svg>
  );
};

export const FilterIcon: FC<IconProps> = () => {
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.499634 0.999023C0.499634 0.866415 0.552312 0.739238 0.64608 0.64547C0.739849 0.551702 0.867026 0.499023 0.999634 0.499023H12.9996C13.1322 0.499023 13.2594 0.551702 13.3532 0.64547C13.447 0.739238 13.4996 0.866415 13.4996 0.999023V2.99902C13.4996 3.12233 13.454 3.24128 13.3716 3.33302L8.99963 8.19102V12.999C8.99955 13.1039 8.96649 13.2061 8.90511 13.2912C8.84373 13.3763 8.75716 13.4399 8.65763 13.473L5.65763 14.473C5.58251 14.498 5.50251 14.5049 5.42423 14.4929C5.34596 14.481 5.27163 14.4506 5.20738 14.4043C5.14313 14.3581 5.0908 14.2972 5.05468 14.2267C5.01856 14.1562 4.99969 14.0782 4.99963 13.999V8.19102L0.627634 3.33302C0.545242 3.24128 0.499656 3.12233 0.499634 2.99902V0.999023ZM1.49963 1.49902V2.80702L5.87163 7.66502C5.95403 7.75676 5.99961 7.87572 5.99963 7.99902V13.305L7.99963 12.639V7.99902C7.99966 7.87572 8.04524 7.75676 8.12763 7.66502L12.4996 2.80702V1.49902H1.49963Z"
        fill="#05386B"
      />
    </svg>
  );
};

export const DropdownIcon: FC<IconProps> = () => {
  return (
    <svg
      width="14"
      height="8"
      viewBox="0 0 14 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0.645756 0.645267C0.692202 0.598704 0.747377 0.561761 0.808122 0.536555C0.868867 0.511348 0.933989 0.498374 0.999756 0.498374C1.06552 0.498374 1.13064 0.511348 1.19139 0.536555C1.25213 0.561761 1.30731 0.598704 1.35376 0.645267L6.99976 6.29227L12.6458 0.645267C12.6922 0.59878 12.7474 0.561903 12.8082 0.536744C12.8689 0.511585 12.934 0.498636 12.9998 0.498636C13.0655 0.498636 13.1306 0.511585 13.1913 0.536744C13.2521 0.561903 13.3073 0.59878 13.3538 0.645267C13.4002 0.691755 13.4371 0.746944 13.4623 0.807684C13.4874 0.868423 13.5004 0.933524 13.5004 0.999268C13.5004 1.06501 13.4874 1.13011 13.4623 1.19085C13.4371 1.25159 13.4002 1.30678 13.3538 1.35327L7.35376 7.35327C7.30731 7.39983 7.25213 7.43677 7.19139 7.46198C7.13064 7.48719 7.06552 7.50016 6.99976 7.50016C6.93399 7.50016 6.86887 7.48719 6.80812 7.46198C6.74738 7.43677 6.6922 7.39983 6.64576 7.35327L0.645756 1.35327C0.599193 1.30682 0.56225 1.25165 0.537043 1.1909C0.511837 1.13016 0.498862 1.06503 0.498862 0.999268C0.498862 0.9335 0.511837 0.868379 0.537043 0.807634C0.56225 0.746889 0.599193 0.691713 0.645756 0.645267Z"
        fill="#6B7075"
      />
    </svg>
  );
};

export const CopyIcon: FC<IconProps> = ({className}) => {
  return (
    <svg
      width="17"
      height="20"
      viewBox="0 0 17 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M14.25 0H5.5C4.83696 0 4.20107 0.263392 3.73223 0.732233C3.26339 1.20107 3 1.83696 3 2.5C2.33696 2.5 1.70107 2.76339 1.23223 3.23223C0.763392 3.70107 0.5 4.33696 0.5 5V17.5C0.5 18.163 0.763392 18.7989 1.23223 19.2678C1.70107 19.7366 2.33696 20 3 20H11.75C12.413 20 13.0489 19.7366 13.5178 19.2678C13.9866 18.7989 14.25 18.163 14.25 17.5C14.913 17.5 15.5489 17.2366 16.0178 16.7678C16.4866 16.2989 16.75 15.663 16.75 15V2.5C16.75 1.83696 16.4866 1.20107 16.0178 0.732233C15.5489 0.263392 14.913 0 14.25 0V0ZM14.25 16.25V5C14.25 4.33696 13.9866 3.70107 13.5178 3.23223C13.0489 2.76339 12.413 2.5 11.75 2.5H4.25C4.25 2.16848 4.3817 1.85054 4.61612 1.61612C4.85054 1.3817 5.16848 1.25 5.5 1.25H14.25C14.5815 1.25 14.8995 1.3817 15.1339 1.61612C15.3683 1.85054 15.5 2.16848 15.5 2.5V15C15.5 15.3315 15.3683 15.6495 15.1339 15.8839C14.8995 16.1183 14.5815 16.25 14.25 16.25ZM1.75 5C1.75 4.66848 1.8817 4.35054 2.11612 4.11612C2.35054 3.8817 2.66848 3.75 3 3.75H11.75C12.0815 3.75 12.3995 3.8817 12.6339 4.11612C12.8683 4.35054 13 4.66848 13 5V17.5C13 17.8315 12.8683 18.1495 12.6339 18.3839C12.3995 18.6183 12.0815 18.75 11.75 18.75H3C2.66848 18.75 2.35054 18.6183 2.11612 18.3839C1.8817 18.1495 1.75 17.8315 1.75 17.5V5Z"
        fill="#05386B"
      />
    </svg>
  );
};

export const DropUpIcon: FC<IconProps> = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.3541 11.3541C14.3076 11.4006 14.2525 11.4376 14.1917 11.4628C14.131 11.488 14.0659 11.501 14.0001 11.501C13.9343 11.501 13.8692 11.488 13.8084 11.4628C13.7477 11.4376 13.6925 11.4006 13.6461 11.3541L8.00008 5.70708L2.35408 11.3541C2.3076 11.4006 2.25241 11.4374 2.19167 11.4626C2.13093 11.4878 2.06583 11.5007 2.00008 11.5007C1.93434 11.5007 1.86924 11.4878 1.8085 11.4626C1.74776 11.4374 1.69257 11.4006 1.64608 11.3541C1.5996 11.3076 1.56272 11.2524 1.53756 11.1917C1.5124 11.1309 1.49945 11.0658 1.49945 11.0001C1.49945 10.9343 1.5124 10.8692 1.53756 10.8085C1.56272 10.7478 1.5996 10.6926 1.64608 10.6461L7.64608 4.64608C7.69253 4.59952 7.74771 4.56258 7.80845 4.53737C7.8692 4.51216 7.93432 4.49919 8.00008 4.49919C8.06585 4.49919 8.13097 4.51216 8.19172 4.53737C8.25246 4.56258 8.30764 4.59952 8.35408 4.64608L14.3541 10.6461C14.4006 10.6925 14.4376 10.7477 14.4628 10.8084C14.488 10.8692 14.501 10.9343 14.501 11.0001C14.501 11.0659 14.488 11.131 14.4628 11.1917C14.4376 11.2525 14.4006 11.3076 14.3541 11.3541Z"
        fill="#6B7075"
      />
    </svg>
  );
};

export const BreadCrumSeparator: FC = () => {
  return (
    <svg
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0.646447 0.646447C0.841709 0.451184 1.15829 0.451184 1.35355 0.646447L7.35355 6.64645C7.54882 6.84171 7.54882 7.15829 7.35355 7.35355L1.35355 13.3536C1.15829 13.5488 0.841709 13.5488 0.646447 13.3536C0.451184 13.1583 0.451184 12.8417 0.646447 12.6464L6.29289 7L0.646447 1.35355C0.451184 1.15829 0.451184 0.841709 0.646447 0.646447Z"
        fill="#404346"
      />
    </svg>
  );
};
